module.exports = __webpack_public_path__ + "src/components/Menu/assets/net-1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu/assets/net-1.svg
// module id = 2919
// module chunks = 14